import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommentsComponent } from "../../../shared/components/comments/comments.component";
import { ActivatedRoute } from '@angular/router';
import { ModelType } from '@shared/constants/model-type.enum';
import { IGeneralData } from '@models/general-data.model';
import { GeneralService } from 'src/app/services/general.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-general',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, CommentsComponent],
  templateUrl: './general.component.html',
  styleUrl: './general.component.scss'
})
export class GeneralComponent implements OnInit {
  generalService = inject(GeneralService);
  sharedService = inject(SharedService);
  loading: boolean = false;
  showComments: boolean = false;
  label: string = '';
  treeId!: number;
  modelType!: ModelType;
  warningLabel: string = "WARNING: This project has not yet been approved for general application by the global formulators. If you are using the models in this project to predict test results, determine impact of formulation changes, or estimate probability of pass to make program plans and budget estimates or to share with customers, you should consult with the formulator and or the statistician responsible to understand applicability."
  generalData!: IGeneralData;
  projectId: number = 0;
  parentLabel: string = '';

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.label = params['label'];
      this.modelType = params['modelType'];
      this.treeId = params['treeId'];
      this.projectId = params['projectId'];
      this.parentLabel = params['parentLabel'];
      this.getGeneralData();
    });
  }

  getGeneralData(): void {
    this.loading = true;
    this.generalService.getGeneralData(this.projectId, this.modelType).subscribe((data: IGeneralData) => {
      this.generalData = data;
      this.sharedService.setPromotionLevel(data.promotionLevel);
      this.loading = false;
    });
  }
}
